import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-9 gap-[10px] items-stretch" }
const _hoisted_2 = { class: "font-semibold text-xl leading-[24px]" }
const _hoisted_3 = { class: "cursor-pointer text-xl leading-[24px] font-normal" }
const _hoisted_4 = { class: "max-w-96 text-left" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "max-w-96 text-left" }
const _hoisted_7 = { class: "cursor-pointer text-base leading-[20px] text-black" }
const _hoisted_8 = { class: "max-w-96" }
const _hoisted_9 = { class: "text-left" }


import AppTooltip from "@/components/AppTooltip.vue";
import { Luck10 } from "@/types/calculators";


export default /*@__PURE__*/_defineComponent({
  __name: 'DecadesOfLuck',
  props: {
    startYear: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

function scoreClass(score: number) {
  if (score >= 3) return "text-black border-[#c3e6cb]";
  if (score >= -5 && score <= -2) return "border-[#f5c6cb] text-black";
  return "border-[#d6d8db] text-black";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: _normalizeClass(["flex md:flex-col flex-grow gap-4 border-2 py-2 rounded-lg max-md:px-4 items-center max-md:justify-between bg-white", scoreClass(item.score)])
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(props.startYear + i * 10), 1),
        _createVNode(AppTooltip, null, {
          trigger: _withCtx(() => [
            _createElementVNode("p", _hoisted_3, _toDisplayString(item.pillar), 1)
          ]),
          popper: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.tips.pillar), 1)
          ]),
          _: 2
        }, 1024),
        _createVNode(AppTooltip, null, {
          trigger: _withCtx(() => [
            _createElementVNode("img", {
              src: require(`@/assets/calculators/bazi/${item.element}.png`),
              alt: item.element,
              class: "cursor-pointer mx-auto size-10"
            }, null, 8, _hoisted_5)
          ]),
          popper: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.tips.element), 1)
          ]),
          _: 2
        }, 1024),
        _createVNode(AppTooltip, null, {
          trigger: _withCtx(() => [
            _createElementVNode("p", _hoisted_7, _toDisplayString(item.stage), 1)
          ]),
          popper: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h5", null, _toDisplayString(item.tips.stage_label), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(item.tips.stage), 1)
            ])
          ]),
          _: 2
        }, 1024)
      ], 2))
    }), 128))
  ]))
}
}

})